define('bizzabo/models/MultiAdmin',[
    'jquery',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'underscore',
    'backbone',
    'bizzabo/models/Global',
    'bizzabo/consts',
    'socket-io',
    'bizzabo/views/popup/TakeOverView',
    'bizzabo/config'
], function(
    $,
    BZAPI,
    UTILS,
    _,
    Backbone,
    Global,
    Consts,
    io,
    TakeOverView,
    Config
    ) {

    var MultiAdmin = Backbone.Model.extend({

        pollerInterval: 3000,

        lockedRoomsMapping: ['agenda', 'polls', 'sponsors'],

        initialize: function() {
            _.bindAll(this, 'registerOnDynamicRoom', 'setRoomMaster', 'startRoomMasterPoller', 'showTakeOverNotification', 'takeOverSuccess', 'startAcquireRoomPoller',
                'takeOverFail', 'setEditorName', 'clientDisconnected', 'roomMasterLeft', 'setSocketPayload', 'clearRoomMaster', 'reconnect', 'takeOver', 'giveAccessIfNeeded');
            this.socket = io.connect(Config.REALTIME_URL, {reconnection: Config.shouldSocketIoReconnect});
            this.socket.on('takeOverRequest', this.showTakeOverNotification);
            this.socket.on('setEditorName', this.setEditorName);
            this.socket.on('setRoomMaster', this.setRoomMaster);
            this.socket.on('reconnect', this.reconnect);
            this.socket.on('disconnect', this.clientDisconnected);
            this.socket.on('takeOverFail', this.takeOverFail);
            this.socket.on('takeOverSuccess', this.takeOverSuccess);
            this.socket.on( 'roomMasterLeft',this.roomMasterLeft);

            this.listenTo(Backbone, Consts.Notifications.activeEvent.SWITCHED, this.eventIsReady);
            this.listenTo(Backbone,Consts.Notifications.mainPage.SAVE_ALL_REQUEST, this.handleTakeOver);
            this.listenTo(Backbone, Consts.Notifications.mainPage.SAVE_ALL_REQUEST_COMPLETED, this.giveAccessIfNeeded);
            this.listenTo(Backbone, Consts.Notifications.mainPage.PUBLISH_ALL_REQUEST, this.handleTakeOver);
            this.listenTo(Backbone, Consts.Notifications.mainPage.PUBLISH_ALL_REQUEST_COMPLETED, this.giveAccessIfNeeded);
            this.listenTo(Backbone, 'registerOnDynamicRoom', this.registerOnDynamicRoom);
            this.listenTo(Backbone, 'leaveDynamicRoom', this.leaveDynamicRoom);
            if (this.get('appRouter')){
                this.listenTo(this.get('appRouter'), 'route', this.manageRooms);
            }
            try {
                window._printSocketLog = window.localStorage.getItem('socket-log');
            }
            catch (e) {
                return;
            }
        },

        eventIsReady : function() {
            this.printSocketLog('event is ready');
            this.eventId = Global.modelPool.getActiveEvent().get('id');
        },

        printSocketLog : function (msg, data) {
            if (window._printSocketLog) {
                var dataString = JSON.stringify(data) || '';
                console.log(msg, dataString);
            }
        },

        roomMasterLeft: function (data){
            this.printSocketLog('Room master left', {room1: data.roomName, room2: this.socketPayload.roomName});
            if (data.roomName !== this.socketPayload.roomName){
                return;
            }
            //room master left the room. if socket is bizzabo admin dont request the acquire room
             if (this.socketPayload && this.socketPayload.isBizzaboAdmin) {
                 this.setEditorName('no one');
                 return;
            }
            this.roomMasterLeftNotfication = true;
            Global.multiAdmin.socket.emit('acquireRoomMaster', this.socketPayload);
        },

        manageRooms: function (routeName) {
            var thisModel = this;
            if (!Global.modelPool.getActiveEvent()) {
                setTimeout(function () {
                    thisModel.manageRooms(routeName);
                }, 500);
                return;
            }
            this.routeName = routeName;
            if (this.routeName === this.oldRouteName) {
                return;
            }
            if (this.isRequireLock(this.routeName)) {
                this.registerOnDynamicRoom(this.routeName);
            }
            this.oldRouteName = routeName;
        },

        isRequireLock: function (routeName) {
            var requireLock = _.find(this.lockedRoomsMapping, function(lockedRoomName){ return routeName === lockedRoomName; });
            return requireLock;
        },

        setSocketPayload: function (roomName) {
            this.socketPayload = {
                roomName: roomName,
                eventId: Global.modelPool.getActiveEvent().get('id'),
                personName: Global.modelPool.getMe().get('first-name') + ' ' + Global.modelPool.getMe().get('last-name'),
                bizzaboId: Global.modelPool.getMe().get('id'),
                isBizzaboAdmin: Global.modelPool.getMe().get('admin'),
                socketId: Global.multiAdmin.socket.io.engine.id
            };
        },

        getSocketPayload: function () {
            return this.socketPayload;
        },

        clientDisconnected: function () {
            this.printSocketLog('client disconnected');
            this.leaveDynamicRoom(this.socketPayload.roomName);
            this.clearRoomMaster();
        },

        setRoomMaster: function(data){
            this.printSocketLog('set room master', {'dataRoom' : data.roomName, 'socketRoom': this.socketPayload.roomName});
            if (data.roomName && this.socketPayload.roomName && data.roomName !== this.socketPayload.roomName){
                return;
            }
            this.printSocketLog('Room Master', data.setRoomMaster);
            this.roomMaster = data.setRoomMaster;
            Global.modelPool.getActiveEvent().set('event-is-active', !this.roomMaster);
            if (this.roomMaster) {
                this.stopAcquireRoomPoller();
                Backbone.trigger('removeNotification', Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG);
                this.printSocketLog('you are in control of the room!!!');
                Global.multiAdmin.updateModels(data.roomName);
                this.startRoomMasterPoller();
                if (this.roomMasterLeftNotfication) {
                    this.successNotificationMessage();
                    this.roomMasterLeftNotfication = false;
                }
            }
            else {
                this.stopRoomMasterPoller();
                this.startAcquireRoomPoller();
            }
        },

        stopRoomMasterPoller: function () {
            clearInterval(this.extensionInterval);
        },

        startRoomMasterPoller: function () {
            this.printSocketLog('Starting room master poller');
            var thisModel = this;
            if (this.extensionInterval){
                clearInterval(this.extensionInterval);
            }
            this.extensionInterval = setInterval(function () {
                if (!thisModel.socketPayload.socketId) {
                    thisModel.setSocketPayload(thisModel.socketPayload.roomName);
                }

                if (!thisModel.routeName) {
                    return;
                }

                Global.multiAdmin.socket.emit('extendRoomMasterExpirationTime', thisModel.socketPayload);
            },this.pollerInterval);
        },

        clearRoomMaster: function() {
            this.stopRoomMasterPoller();
            this.stopAcquireRoomPoller();
            this.roomMasterLeftNotfication = false;
        },

        startAcquireRoomPoller: function () {
            var thisModel = this;

            if (this.socketPayload && this.socketPayload.isBizzaboAdmin) {
                return;
            }

            if (this.acquireRoomMasterInterval){
                clearInterval(this.acquireRoomMasterInterval);
            }
            this.acquireRoomMasterInterval = setInterval(function () {
                if (!thisModel.socketPayload.socketId) {
                    thisModel.setSocketPayload(thisModel.socketPayload.roomName);
                }
                Global.multiAdmin.socket.emit('acquireRoomMaster' , thisModel.socketPayload);
            },this.pollerInterval * 2);
        },

        stopAcquireRoomPoller: function() {
            clearInterval(this.acquireRoomMasterInterval);
        },

        reconnect: function () {
            this.manageRooms(this.routeName);
        },

        registerOnDynamicRoom : function(roomName) {
            this.setSocketPayload(roomName);
            this.printSocketLog('registerOnDynamicRoom room name', roomName);
            Global.multiAdmin.socket.emit('registerOnDynamicRoom', this.socketPayload, BZAPI.token());
        },

        leaveDynamicRoom: function (roomName) {
            this.printSocketLog('leaveDynamicRoom', {'roomName' : roomName});
            this.setSocketPayload(this.routeName);
            Global.multiAdmin.socket.emit('releaseEvent', this.socketPayload);
            Global.multiAdmin.socket.emit('leaveRoom', this.socketPayload);
            this.clearRoomMaster();
            Global.modelPool.getActiveEvent().set('event-is-active', false);
        },

       takeOver : function() {
           var thisView =this;
           Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
               msg : "Taking over control.",
               autoHide : true,
               hideAfter : 11000,
               showCountDown : true,
               errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.TIP
           });

           var secondsCounter = 9;
           var interval = setInterval(function(){
               $('.take-over-countdown').html(secondsCounter);
               secondsCounter--;
               if (secondsCounter == 0) {
                   clearInterval(interval);
               }
           }, 1000);

           this.noAnswer = setTimeout(function() {
               thisView.clearRoomMaster();
               thisView.duringTakeOver = false;
               thisView.setRoomMaster({'setRoomMaster':true, 'roomName': thisView.socketPayload.roomName});
               Global.multiAdmin.socket.emit('giveAccessToMyself', thisView.getSocketPayload());
           }, 15000);

           Global.multiAdmin.socket.emit('takeOver', this.socketPayload);
       },

        takeOverSuccess: function() {
            clearTimeout(this.noAnswer);
            this.printSocketLog('takeOverSuccess true');
            this.setRoomMaster({setRoomMaster: true, 'roomName': this.socketPayload.roomName});
            this.successNotificationMessage();
            Global.multiAdmin.updateModels(this.socketPayload.roomName);
            Global.modelPool.getActiveEvent().set('event-is-active', false);
        },

        successNotificationMessage:function() {
            setTimeout(function(){
                Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                    msg : " This page is under your control now, Captain!",
                    autoHide : true,
                    errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.TIP
                });
            }, 1000);
        },

        takeOverFail: function() {
            clearTimeout(this.noAnswer);
            Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                msg :Global.multiAdmin.editorName + " has denied your edit request.",
                autoHide : true,
                errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.TIP
            });
            setTimeout(function(){
                Backbone.trigger(Consts.Notifications.multiAdmin.TAKE_OVER);
            }, 10000);
        },

        showTakeOverNotification : function(socketRequestingControl) {
            //if you are not the room master message is irrelevant
            if (!this.roomMaster) { //todo to check if needed
                return;
            }
            this.printSocketLog('show take over notification', {'room1': socketRequestingControl.roomName, 'room2': this.socketPayload.roomName});
            if (this.roomMaster && socketRequestingControl.roomName !== this.socketPayload.roomName) {
                return;
            }
            //automatically deny take over request while taking over request is in progress.
            if (this.duringTakeOver) {
                this.printSocketLog('during take over. deny access');
                this.denyAccess(socketRequestingControl);
                return;
            }
            this.duringTakeOver = true;
            this.socketRequestingControl = socketRequestingControl;

            var thisSocket = this;
            var deniedAccess = false;
            Global.multiAdmin.set('deniedAccess', false);

            var takeOverPopup = new TakeOverView(
                {
                    title: "Knock Knock",
                    html: '<p>' +  Global.multiAdmin.editorName +  ' has asked to edit this page. If you allow him/her to take over, You will lose all unsaved data</p>'
                });
            takeOverPopup.show();

            var secondsCounter = 9;
            var interval = setInterval(function(){
                $('.take-over-countdown').html(secondsCounter);
                secondsCounter--;
                if (secondsCounter == 0) {
                    clearInterval(interval);
                }
            }, 1000);

            Global.multiAdmin.giveAccessTimeout = setTimeout(function() {
                takeOverPopup.hide();
                if (!Global.multiAdmin.get('deniedAccess')) {
                    Global.multiAdmin.socket.emit('giveAccess', thisSocket.socketRequestingControl);
                }
                clearTimeout(Global.multiAdmin.giveAccessTimeout);
                Global.multiAdmin.giveAccessTimeout = undefined;
            }, 10000);
        },

        denyAccess : function(socketRequestingControl) {
            socketRequestingControl = socketRequestingControl || this.socketRequestingControl;
            Global.multiAdmin.socket.emit('denyAccess', socketRequestingControl);
            if (this.socketRequestingControl.socketId === socketRequestingControl.socketId){
                //first requesting socket denied. initialize duringTakeOver flag and requesting socket information.
                this.duringTakeOver = false;
            }
        },

        setEditorName : function(name) {
            Global.multiAdmin.editorName = name;
            Global.multiAdmin.setTooltip();
            Backbone.trigger(Consts.Notifications.multiAdmin.EDITOR_NAME_CHANGED);
        },

        getModelForRoom: function(roomName, eventId) {
            var modelForRoom = {
                sponsors: {
                    model: Global.modelPool.getPartners(eventId),
                    reset: true
                },
                polls: {
                    model: Global.modelPool.getPolls(eventId),
                    reset: false
                },
                agenda: {
                    model: Global.modelPool.getAgenda(eventId),
                    reset: false
                }
            };
            return modelForRoom[roomName];
        },

        updateModels : function(roomName) {
            var activeEvent = Global.modelPool.getActiveEvent();
            if (activeEvent.get('id')) {
                activeEvent.fetch();
                var modelForRoom = this.getModelForRoom(roomName, activeEvent.get('id'));
                modelForRoom.model.fetch({reset: modelForRoom.reset});
            }
        },

        handleTakeOver : function() {
            if (Global.multiAdmin.giveAccessTimeout) {
                clearTimeout(this.giveAccessTimeout);
                Global.multiAdmin.giveAccessTimeout = undefined;
                Global.multiAdmin.timeOutCleared = true;
            }
        },

        giveAccessIfNeeded : function(saveSuccessfull) {
            if (Global.multiAdmin.timeOutCleared) {
                if (saveSuccessfull) {
                    this.duringTakeOver = false;
                    this.clearRoomMaster();
                    this.setRoomMaster({'setRoomMaster':false, 'roomName': this.socketPayload.roomName});
                    Global.multiAdmin.socket.emit('giveAccess', this.socketRequestingControl);
                } else {
                    Global.multiAdmin.denyAccess(this.socketRequestingControl);
                }
                Global.multiAdmin.timeOutCleared = false;
            }
        },

        setTooltip : function() {
            $('.activeTab').attr('data-original-title', Global.multiAdmin.editorName);
        }
    });

    return MultiAdmin;

});
